import { selectChoices } from './components/options.js';
import { instantiate } from './components/instantiate.js';
import { flattenAllOf } from './components/flatten-allof.js';
/**
 * Instantiate an architecture from a pattern. Pure: no filesystem access, errors propagate.
 */
export async function generate(pattern, schemaDirectory, options = {}) {
    const debug = options.debug ?? false;
    await schemaDirectory.loadSchemas();
    let flattenedPattern = await flattenAllOf(pattern, schemaDirectory, debug);
    if (options.chosenChoices) {
        flattenedPattern = selectChoices(flattenedPattern, options.chosenChoices, debug);
    }
    return instantiate(flattenedPattern, debug, schemaDirectory);
}
//# sourceMappingURL=generate-core.js.map